import * as React from 'react';

export enum ScoreType {
  Cancellation = 'cancellation',
  Timeliness = 'timeliness',
}

export interface IReliabilityScore {
  [key: string]: {
    count: number;
    score: number;
    target: number;
    details: {
      [key: string]: number;
    }
  }
}

interface BackOutDetailsProps {
  reliabilityScore: IReliabilityScore;
  isOpen: boolean;
  onClose: () => void;
  providerId: number;
}

export class BackOutDetails extends React.Component<BackOutDetailsProps, any> {}